"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Felecan Rares
 * @Date 2025/10/30
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMemoryUsageReporting = initMemoryUsageReporting;
const port_1 = require("./messages/port");
const constants_1 = require("./constants");
const const_1 = require("./messages/const");
function bytesToMegabytes(bytes) {
    return parseFloat((bytes / (1024 * 1024)).toFixed(3));
}
function sendMemoryUsageEvent() {
    const memoryMeasurement = performance.memory;
    const memoryUsageInMB = {
        jsHeapSizeLimit: bytesToMegabytes(memoryMeasurement.jsHeapSizeLimit),
        totalJSHeapSize: bytesToMegabytes(memoryMeasurement.totalJSHeapSize),
        usedJSHeapSize: bytesToMegabytes(memoryMeasurement.usedJSHeapSize),
    };
    const data = {
        type: constants_1.INTERNAL_MESSAGE_TYPE,
        message: {
            name: const_1.SEND_INTERNAL_MESSAGE.MEMORY_USAGE,
            value: memoryUsageInMB,
        },
    };
    (0, port_1.sendMessage)(data);
}
function initMemoryUsageReporting() {
    if (performance === null || performance === void 0 ? void 0 : performance.memory) {
        sendMemoryUsageEvent();
        // push memory measurement every 5 minutes
        setInterval(sendMemoryUsageEvent, 5 * 60 * 1000);
    }
}
//# sourceMappingURL=memoryUsage.js.map